import { Button } from "@chakra-ui/react";

export default function VerifyCodeButton({ children, ...rest }) {
  return (
    <Button
      minWidth="170px"
      py="12px"
      px="24px"
      bg="white"
      color="primary"
      borderRadius="18px"
      fontSize="12px"
      lineHeight="1.17"
      fontWeight={600}
      letterSpacing="0.15px"
      {...rest}
    >
      {children}
    </Button>
  );
}
